import React from "react";

import { HospitalBasicForm } from './form/HospitalBasicForm';
import { InsuranceForm } from './form/InsuranceForm';
import { AvailableForm } from './form/AvailableForm';
import { UnavailableForm } from './form/UnavailableForm';
import { EditHospitalSideBar } from './parts/EditHospitalSideBar';

export const HospitalEdit = (props) => {
  const { init_hospital, insurances, corporations, staff_user } = props;

  return (
    <>
      <div className="row">
        <div className="col-9">
          <HospitalBasicForm init_hospital={init_hospital} />
          <InsuranceForm init_hospital={init_hospital} insurances={insurances} />
          <AvailableForm init_hospital={init_hospital} corporations={corporations} />
          <UnavailableForm init_hospital={init_hospital} corporations={corporations} />
        </div>
        <div className="col-3">
          <EditHospitalSideBar init_hospital={init_hospital} staff_user={staff_user} />
        </div>
      </div>
    </>
  );
};